//@import dependencies
import React, {useState} from 'react'
//@end

//@import components
import {AuthLayout} from 'app_components/layouts/auth'
import LoginModule from 'app_components/modules/login'
// import IconComponent from 'app_components/commons/icons'
//@end

//@import service
// import {routingService} from 'app_services/routingService'
import CompanyService from 'app_services/campus/company/companyService'
//@end

// @import types
import { IUserHttpResponse } from 'app_types/userTypes'
// @end

// @INFO Import Styles
import './../loginScreen.scss'

// @ADD Component types
interface ILoginScreenLayoutProps {
  error: string | null
  onHandleLogin: (credentials: any) => void
  onHandlePasswordRecover: (userData: IUserHttpResponse) => void
  history?: any
}

const LoginScreenLayout: React.FC<ILoginScreenLayoutProps> = (props) => {

  const companyService: CompanyService = new CompanyService()
  const [company, setCompany] = useState<any>(null)
  const [background, setBackground] = useState<any>(require('app_assets/images/resources/login/background.jpg'))

  const handleCompanySelected = async (selected: {value: string, label: string}) => {
    const companyResponse = await companyService.fetchCompany({id: selected.value})
    if (companyResponse.status === 'success') {
      setBackground(companyResponse.company.background)
      setCompany(companyResponse.company)
    }
  }

  return(
    <AuthLayout
      background={background}
      error={props.error}
      company={company}
    >
        <LoginModule
          onSubmit={props.onHandleLogin}
          company={company}
          onCompanySelected={handleCompanySelected}
          onHandlePasswordRecover={props.onHandlePasswordRecover}
          history={props.history}
        />
    </AuthLayout>
  )
}

export default LoginScreenLayout
